// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsNavigation-module__font-s-10___zGSdn {
  font-size: 10px !important;
}

.TabsNavigation-module__font-s-12___ptP_q {
  font-size: 12px !important;
}

.TabsNavigation-module__font-s-13___sI952 {
  font-size: 13px !important;
}

.TabsNavigation-module__font-s-14___aiqlj {
  font-size: 14px !important;
}

.TabsNavigation-module__font-s-15___S4cwm {
  font-size: 15px !important;
}

.TabsNavigation-module__font-s-16___SIOuF {
  font-size: 16px !important;
}

.TabsNavigation-module__font-s-18___W6Dqe {
  font-size: 18px !important;
}

.TabsNavigation-module__font-s-20___mxYoH {
  font-size: 20px !important;
}

.TabsNavigation-module__font-s-22___eUqyV {
  font-size: 22px !important;
}

.TabsNavigation-module__font-s-28___CyOB8 {
  font-size: 28px !important;
}

.TabsNavigation-module__font-w-400___xrult {
  font-weight: 400 !important;
}

.TabsNavigation-module__font-w-500___sQuer {
  font-weight: 500 !important;
}

.TabsNavigation-module__font-w-600___EpG_C {
  font-weight: 600 !important;
}

.TabsNavigation-module__font-w-700___zma3t {
  font-weight: 700 !important;
}

.TabsNavigation-module__p-5___n7Pey {
  padding: 5px !important;
}

.TabsNavigation-module__p-12___bevgH {
  padding: 12px !important;
}

.TabsNavigation-module__p-16___S15ee {
  padding: 16px !important;
}

.TabsNavigation-module__p-30___qM3xw {
  padding: 30px !important;
}

.TabsNavigation-module__p-b-0___iqyYb {
  padding-bottom: 0 !important;
}

.TabsNavigation-module__p-b-5___g7rV9 {
  padding-bottom: 5px !important;
}

.TabsNavigation-module__p-b-10___Zc8YT {
  padding-bottom: 10px !important;
}

.TabsNavigation-module__p-b-12___GiXBO {
  padding-bottom: 12px !important;
}

.TabsNavigation-module__p-b-16___lfZsB {
  padding-bottom: 16px !important;
}

.TabsNavigation-module__p-b-18___OEvRx {
  padding-bottom: 18px !important;
}

.TabsNavigation-module__p-b-20___QYb4u {
  padding-bottom: 20px !important;
}

.TabsNavigation-module__p-b-25___ypg3j {
  padding-bottom: 25px !important;
}

.TabsNavigation-module__p-b-30___Et4L4 {
  padding-bottom: 30px !important;
}

.TabsNavigation-module__p-b-50___HGMCg {
  padding-bottom: 50px !important;
}

.TabsNavigation-module__p-t-0___PHojt {
  padding-top: 0 !important;
}

.TabsNavigation-module__p-t-12___t4IFK {
  padding-top: 12px !important;
}

.TabsNavigation-module__p-t-16___wWkRZ {
  padding-top: 16px !important;
}

.TabsNavigation-module__p-t-18___yBf8O {
  padding-top: 18px !important;
}

.TabsNavigation-module__p-t-20___BU4zn {
  padding-top: 20px !important;
}

.TabsNavigation-module__p-t-30___zpAXb {
  padding-top: 30px !important;
}

.TabsNavigation-module__p-t-40___DGFMt {
  padding-top: 40px !important;
}

.TabsNavigation-module__p-t-50___Y8E5Z {
  padding-top: 50px !important;
}

.TabsNavigation-module__p-l-20___prhSU {
  padding-left: 20px !important;
}

.TabsNavigation-module__p-l-30___Y0E_O {
  padding-left: 30px !important;
}

.TabsNavigation-module__p-l-40___tQ_5C {
  padding-left: 40px !important;
}

.TabsNavigation-module__p-r-16___snka8 {
  padding-right: 16px !important;
}

.TabsNavigation-module__p-r-20___RcDum {
  padding-right: 20px !important;
}

.TabsNavigation-module__p-r-30___nZgd3 {
  padding-right: 30px !important;
}

.TabsNavigation-module__p-r-50___GnFt8 {
  padding-right: 50px !important;
}

.TabsNavigation-module__p-r-60___AKbIU {
  padding-right: 60px !important;
}

.TabsNavigation-module__m-b-1___CVg1s {
  margin-bottom: 1px !important;
}

.TabsNavigation-module__m-b-2___UWLz1 {
  margin-bottom: 2px !important;
}

.TabsNavigation-module__m-b-6___B8ymV {
  margin-bottom: 6px !important;
}

.TabsNavigation-module__m-b-8___eeHhm {
  margin-bottom: 8px !important;
}

.TabsNavigation-module__m-b-10___yVEf2 {
  margin-bottom: 10px !important;
}

.TabsNavigation-module__m-b-14___xVRuX {
  margin-bottom: 14px !important;
}

.TabsNavigation-module__m-b-16___p5BvP {
  margin-bottom: 16px !important;
}

.TabsNavigation-module__m-b-20___I21uF {
  margin-bottom: 20px !important;
}

.TabsNavigation-module__m-b-22___vvGaU {
  margin-bottom: 22px !important;
}

.TabsNavigation-module__m-b-24___BNina {
  margin-bottom: 24px !important;
}

.TabsNavigation-module__m-b-30___UFHIL {
  margin-bottom: 30px !important;
}

.TabsNavigation-module__m-b-32___U1cDY {
  margin-bottom: 32px !important;
}

.TabsNavigation-module__m-b-40___I4FRj {
  margin-bottom: 40px !important;
}

.TabsNavigation-module__m-t-2____4ZrW {
  margin-top: 2px !important;
}

.TabsNavigation-module__m-t-3___Myx_p {
  margin-top: 3px !important;
}

.TabsNavigation-module__m-t-4___e0BFs {
  margin-top: 4px !important;
}

.TabsNavigation-module__m-t-5___bSyRS {
  margin-top: 5px !important;
}

.TabsNavigation-module__m-t-8___RsNEl {
  margin-top: 8px !important;
}

.TabsNavigation-module__m-t-10____ci_w {
  margin-top: 10px !important;
}

.TabsNavigation-module__m-t-15___INeQo {
  margin-top: 15px !important;
}

.TabsNavigation-module__m-t-16___nxdvz {
  margin-top: 16px !important;
}

.TabsNavigation-module__m-t-20___I2Z4N {
  margin-top: 20px !important;
}

.TabsNavigation-module__m-t-22___NZXCH {
  margin-top: 22px !important;
}

.TabsNavigation-module__m-t-30___hXtU3 {
  margin-top: 30px !important;
}

.TabsNavigation-module__m-t-32___BxwqC {
  margin-top: 32px !important;
}

.TabsNavigation-module__m-l-auto___fCtwX {
  margin-left: auto !important;
}

.TabsNavigation-module__m-l-4___bLHxR {
  margin-left: 4px !important;
}

.TabsNavigation-module__m-l-5___VbGei {
  margin-left: 5px !important;
}

.TabsNavigation-module__m-l-6___Z9bYx {
  margin-left: 6px !important;
}

.TabsNavigation-module__m-l-8___PYEiP {
  margin-left: 8px !important;
}

.TabsNavigation-module__m-l-10___innL8 {
  margin-left: 10px !important;
}

.TabsNavigation-module__m-l-16___otXWQ {
  margin-left: 16px !important;
}

.TabsNavigation-module__m-l-20___VVfjp {
  margin-left: 20px !important;
}

.TabsNavigation-module__m-l-24___IoEcV {
  margin-left: 24px !important;
}

.TabsNavigation-module__m-l-30___VSTyu {
  margin-left: 30px !important;
}

.TabsNavigation-module__m-l-35___TQHO6 {
  margin-left: 35px !important;
}

.TabsNavigation-module__m-l-40___kEcqp {
  margin-left: 40px !important;
}

.TabsNavigation-module__m-r-8___pFI7N {
  margin-right: 8px !important;
}

.TabsNavigation-module__m-r-10___vIlz4 {
  margin-right: 10px !important;
}

.TabsNavigation-module__m-r-16___QMTPs {
  margin-right: 16px !important;
}

.TabsNavigation-module__m-r-20___bpDJ_ {
  margin-right: 20px !important;
}

.TabsNavigation-module__m-r-24___aKygl {
  margin-right: 24px !important;
}

.TabsNavigation-module__m-r-30___k4319 {
  margin-right: 30px !important;
}

.TabsNavigation-module__m-r-40___cfBRf {
  margin-right: 40px !important;
}

.TabsNavigation-module__border-r-3___I8tqu {
  border-radius: 3px !important;
}

.TabsNavigation-module__border-r-4___f5NKs {
  border-radius: 4px !important;
}

.TabsNavigation-module__border-r-6___MDG1D {
  border-radius: 6px !important;
}

.TabsNavigation-module__border-r-10___Tsygy {
  border-radius: 10px !important;
}

.TabsNavigation-module__border-r-12____8ywY {
  border-radius: 12px !important;
}

.TabsNavigation-module__border-r-16___Naudf {
  border-radius: 16px !important;
}

.TabsNavigation-module__border-r-50___g_Sco {
  border-radius: 50% !important;
}

.TabsNavigation-module__primary-border____iTor {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsNavigation-module__primary-border-b___aiPKs {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsNavigation-module__primary-border-t___y4UnW {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsNavigation-module__primary-border-l___PMXCa {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsNavigation-module__primary-border-r___Ed2X8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsNavigation-module__secondary-border___RlRnJ {
  border: 1px solid #637768;
}

.TabsNavigation-module__secondary-border-b___hZa1y {
  border-bottom: 1px solid #637768;
}

.TabsNavigation-module__secondary-border-t___IHOhk {
  border-top: 1px solid #637768;
}

.TabsNavigation-module__secondary-border-l___uRUbm {
  border-left: 1px solid #637768;
}

.TabsNavigation-module__secondary-border-r___PyR8e {
  border-right: 1px solid #637768;
}

.TabsNavigation-module__gap-0___nHT7u {
  gap: 0 !important;
}

.TabsNavigation-module__gap-2___hLFg7 {
  gap: 2px !important;
}

.TabsNavigation-module__gap-4___boTuM {
  gap: 4px !important;
}

.TabsNavigation-module__gap-5___devmw {
  gap: 5px !important;
}

.TabsNavigation-module__gap-6___aWqQ0 {
  gap: 6px !important;
}

.TabsNavigation-module__gap-8___mn9iJ {
  gap: 8px !important;
}

.TabsNavigation-module__gap-10___bBSO3 {
  gap: 10px !important;
}

.TabsNavigation-module__gap-12___vpt0u {
  gap: 12px !important;
}

.TabsNavigation-module__gap-14___Vr01U {
  gap: 14px !important;
}

.TabsNavigation-module__gap-16___dEvHr {
  gap: 16px !important;
}

.TabsNavigation-module__gap-18___mbFAi {
  gap: 18px !important;
}

.TabsNavigation-module__gap-20___KvzoH {
  gap: 20px !important;
}

.TabsNavigation-module__gap-24___CIi9s {
  gap: 24px !important;
}

.TabsNavigation-module__gap-26___iAwzW {
  gap: 26px !important;
}

.TabsNavigation-module__gap-30___MgLVc {
  gap: 30px !important;
}

.TabsNavigation-module__gap-32___Odvhj {
  gap: 32px !important;
}

.TabsNavigation-module__gap-40___urY7S {
  gap: 40px !important;
}

.TabsNavigation-module__gap-50___qmgIe {
  gap: 50px !important;
}

.TabsNavigation-module__flex-1___FhT2e {
  flex: 1;
}

.TabsNavigation-module__flex-none___di5Oe {
  flex: none !important;
}

.TabsNavigation-module__flex-column___zgrK2 {
  display: flex;
  flex-direction: column !important;
}

.TabsNavigation-module__flex-row___zaPim {
  display: flex;
  flex-direction: row !important;
}

.TabsNavigation-module__vertically-centered___sDlGK {
  display: flex;
  align-items: center !important;
}

.TabsNavigation-module__horizontally-centered___liLCl {
  display: flex;
  justify-content: center !important;
}

.TabsNavigation-module__horizontally-end___o3hQh {
  display: flex;
  justify-content: end !important;
}

.TabsNavigation-module__vertically-start___Td1Q6 {
  display: flex;
  align-items: start !important;
}

.TabsNavigation-module__space-between___SQwhG {
  display: flex;
  justify-content: space-between !important;
}

.TabsNavigation-module__flex-wrap___nbx8T {
  flex-wrap: wrap !important;
}

.TabsNavigation-module__height-100___LXlpU {
  height: 100%;
}

.TabsNavigation-module__width-50___ecnMc {
  width: 50% !important;
}

.TabsNavigation-module__width-100___dRURS {
  width: 100%;
}

.TabsNavigation-module__cursor-pointer___kgZe1 {
  cursor: pointer;
}

.TabsNavigation-module__cursor-not-allowed___UzqkI {
  cursor: not-allowed !important;
}

.TabsNavigation-module__absolute-centered___E571T {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TabsNavigation-module__absolute___QN37A {
  position: absolute;
}

.TabsNavigation-module__relative___rQI9I {
  position: relative;
}

.TabsNavigation-module__fixed___hkfe_ {
  position: fixed;
}

.TabsNavigation-module__visible___CVXC3 {
  opacity: 1;
}

.TabsNavigation-module__invisible___wNvf7 {
  opacity: 0;
}

.TabsNavigation-module__col-90___w9mVg {
  width: 90% !important;
}

.TabsNavigation-module__col-auto___un1qg {
  width: auto !important;
}

.TabsNavigation-module__medical-tabs___wJ63d {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TabsNavigation-module__medical-table-new___fobDG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabsNavigation-module__medical-table-new___fobDG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabsNavigation-module__medical-table-new___fobDG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabsNavigation-module__medical-table-new___fobDG::-webkit-scrollbar-track {
  display: none;
}
.TabsNavigation-module__medical-table-new___fobDG.TabsNavigation-module__no-pagination___ChzXP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabsNavigation-module__medical-table-new___fobDG.TabsNavigation-module__no-pagination___ChzXP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabsNavigation-module__medical-table-new___fobDG.TabsNavigation-module__no-pagination___ChzXP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabsNavigation-module__medical-table-new___fobDG.TabsNavigation-module__no-pagination___ChzXP::-webkit-scrollbar-track {
  display: none;
}

.TabsNavigation-module__medical-table-empty___niq04 {
  padding: 14px 40px !important;
}

.TabsNavigation-module__icon-btn___MqE40 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TabsNavigation-module__search-icon___iJlP7 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TabsNavigation-module__disable-select___zT2cK {
  user-select: none;
}

.TabsNavigation-module__break-word___UzDr_ {
  word-break: break-word;
}

.TabsNavigation-module__popup-clear-btn___i0oyw {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TabsNavigation-module__scroll-m-b-20___reRgB {
  scroll-margin-bottom: 20px;
}

.TabsNavigation-module__container___xmDsp {
  height: var(--tabs-navigation);
  background-color: #fdfcfa;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/TabsNavigation/TabsNavigation.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;EACA,yBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: var(--tabs-navigation);\n  background-color: get-color(grayNew, ultra-light);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TabsNavigation-module__font-s-10___zGSdn`,
	"fontS12": `TabsNavigation-module__font-s-12___ptP_q`,
	"fontS13": `TabsNavigation-module__font-s-13___sI952`,
	"fontS14": `TabsNavigation-module__font-s-14___aiqlj`,
	"fontS15": `TabsNavigation-module__font-s-15___S4cwm`,
	"fontS16": `TabsNavigation-module__font-s-16___SIOuF`,
	"fontS18": `TabsNavigation-module__font-s-18___W6Dqe`,
	"fontS20": `TabsNavigation-module__font-s-20___mxYoH`,
	"fontS22": `TabsNavigation-module__font-s-22___eUqyV`,
	"fontS28": `TabsNavigation-module__font-s-28___CyOB8`,
	"fontW400": `TabsNavigation-module__font-w-400___xrult`,
	"fontW500": `TabsNavigation-module__font-w-500___sQuer`,
	"fontW600": `TabsNavigation-module__font-w-600___EpG_C`,
	"fontW700": `TabsNavigation-module__font-w-700___zma3t`,
	"p5": `TabsNavigation-module__p-5___n7Pey`,
	"p12": `TabsNavigation-module__p-12___bevgH`,
	"p16": `TabsNavigation-module__p-16___S15ee`,
	"p30": `TabsNavigation-module__p-30___qM3xw`,
	"pB0": `TabsNavigation-module__p-b-0___iqyYb`,
	"pB5": `TabsNavigation-module__p-b-5___g7rV9`,
	"pB10": `TabsNavigation-module__p-b-10___Zc8YT`,
	"pB12": `TabsNavigation-module__p-b-12___GiXBO`,
	"pB16": `TabsNavigation-module__p-b-16___lfZsB`,
	"pB18": `TabsNavigation-module__p-b-18___OEvRx`,
	"pB20": `TabsNavigation-module__p-b-20___QYb4u`,
	"pB25": `TabsNavigation-module__p-b-25___ypg3j`,
	"pB30": `TabsNavigation-module__p-b-30___Et4L4`,
	"pB50": `TabsNavigation-module__p-b-50___HGMCg`,
	"pT0": `TabsNavigation-module__p-t-0___PHojt`,
	"pT12": `TabsNavigation-module__p-t-12___t4IFK`,
	"pT16": `TabsNavigation-module__p-t-16___wWkRZ`,
	"pT18": `TabsNavigation-module__p-t-18___yBf8O`,
	"pT20": `TabsNavigation-module__p-t-20___BU4zn`,
	"pT30": `TabsNavigation-module__p-t-30___zpAXb`,
	"pT40": `TabsNavigation-module__p-t-40___DGFMt`,
	"pT50": `TabsNavigation-module__p-t-50___Y8E5Z`,
	"pL20": `TabsNavigation-module__p-l-20___prhSU`,
	"pL30": `TabsNavigation-module__p-l-30___Y0E_O`,
	"pL40": `TabsNavigation-module__p-l-40___tQ_5C`,
	"pR16": `TabsNavigation-module__p-r-16___snka8`,
	"pR20": `TabsNavigation-module__p-r-20___RcDum`,
	"pR30": `TabsNavigation-module__p-r-30___nZgd3`,
	"pR50": `TabsNavigation-module__p-r-50___GnFt8`,
	"pR60": `TabsNavigation-module__p-r-60___AKbIU`,
	"mB1": `TabsNavigation-module__m-b-1___CVg1s`,
	"mB2": `TabsNavigation-module__m-b-2___UWLz1`,
	"mB6": `TabsNavigation-module__m-b-6___B8ymV`,
	"mB8": `TabsNavigation-module__m-b-8___eeHhm`,
	"mB10": `TabsNavigation-module__m-b-10___yVEf2`,
	"mB14": `TabsNavigation-module__m-b-14___xVRuX`,
	"mB16": `TabsNavigation-module__m-b-16___p5BvP`,
	"mB20": `TabsNavigation-module__m-b-20___I21uF`,
	"mB22": `TabsNavigation-module__m-b-22___vvGaU`,
	"mB24": `TabsNavigation-module__m-b-24___BNina`,
	"mB30": `TabsNavigation-module__m-b-30___UFHIL`,
	"mB32": `TabsNavigation-module__m-b-32___U1cDY`,
	"mB40": `TabsNavigation-module__m-b-40___I4FRj`,
	"mT2": `TabsNavigation-module__m-t-2____4ZrW`,
	"mT3": `TabsNavigation-module__m-t-3___Myx_p`,
	"mT4": `TabsNavigation-module__m-t-4___e0BFs`,
	"mT5": `TabsNavigation-module__m-t-5___bSyRS`,
	"mT8": `TabsNavigation-module__m-t-8___RsNEl`,
	"mT10": `TabsNavigation-module__m-t-10____ci_w`,
	"mT15": `TabsNavigation-module__m-t-15___INeQo`,
	"mT16": `TabsNavigation-module__m-t-16___nxdvz`,
	"mT20": `TabsNavigation-module__m-t-20___I2Z4N`,
	"mT22": `TabsNavigation-module__m-t-22___NZXCH`,
	"mT30": `TabsNavigation-module__m-t-30___hXtU3`,
	"mT32": `TabsNavigation-module__m-t-32___BxwqC`,
	"mLAuto": `TabsNavigation-module__m-l-auto___fCtwX`,
	"mL4": `TabsNavigation-module__m-l-4___bLHxR`,
	"mL5": `TabsNavigation-module__m-l-5___VbGei`,
	"mL6": `TabsNavigation-module__m-l-6___Z9bYx`,
	"mL8": `TabsNavigation-module__m-l-8___PYEiP`,
	"mL10": `TabsNavigation-module__m-l-10___innL8`,
	"mL16": `TabsNavigation-module__m-l-16___otXWQ`,
	"mL20": `TabsNavigation-module__m-l-20___VVfjp`,
	"mL24": `TabsNavigation-module__m-l-24___IoEcV`,
	"mL30": `TabsNavigation-module__m-l-30___VSTyu`,
	"mL35": `TabsNavigation-module__m-l-35___TQHO6`,
	"mL40": `TabsNavigation-module__m-l-40___kEcqp`,
	"mR8": `TabsNavigation-module__m-r-8___pFI7N`,
	"mR10": `TabsNavigation-module__m-r-10___vIlz4`,
	"mR16": `TabsNavigation-module__m-r-16___QMTPs`,
	"mR20": `TabsNavigation-module__m-r-20___bpDJ_`,
	"mR24": `TabsNavigation-module__m-r-24___aKygl`,
	"mR30": `TabsNavigation-module__m-r-30___k4319`,
	"mR40": `TabsNavigation-module__m-r-40___cfBRf`,
	"borderR3": `TabsNavigation-module__border-r-3___I8tqu`,
	"borderR4": `TabsNavigation-module__border-r-4___f5NKs`,
	"borderR6": `TabsNavigation-module__border-r-6___MDG1D`,
	"borderR10": `TabsNavigation-module__border-r-10___Tsygy`,
	"borderR12": `TabsNavigation-module__border-r-12____8ywY`,
	"borderR16": `TabsNavigation-module__border-r-16___Naudf`,
	"borderR50": `TabsNavigation-module__border-r-50___g_Sco`,
	"primaryBorder": `TabsNavigation-module__primary-border____iTor`,
	"primaryBorderB": `TabsNavigation-module__primary-border-b___aiPKs`,
	"primaryBorderT": `TabsNavigation-module__primary-border-t___y4UnW`,
	"primaryBorderL": `TabsNavigation-module__primary-border-l___PMXCa`,
	"primaryBorderR": `TabsNavigation-module__primary-border-r___Ed2X8`,
	"secondaryBorder": `TabsNavigation-module__secondary-border___RlRnJ`,
	"secondaryBorderB": `TabsNavigation-module__secondary-border-b___hZa1y`,
	"secondaryBorderT": `TabsNavigation-module__secondary-border-t___IHOhk`,
	"secondaryBorderL": `TabsNavigation-module__secondary-border-l___uRUbm`,
	"secondaryBorderR": `TabsNavigation-module__secondary-border-r___PyR8e`,
	"gap0": `TabsNavigation-module__gap-0___nHT7u`,
	"gap2": `TabsNavigation-module__gap-2___hLFg7`,
	"gap4": `TabsNavigation-module__gap-4___boTuM`,
	"gap5": `TabsNavigation-module__gap-5___devmw`,
	"gap6": `TabsNavigation-module__gap-6___aWqQ0`,
	"gap8": `TabsNavigation-module__gap-8___mn9iJ`,
	"gap10": `TabsNavigation-module__gap-10___bBSO3`,
	"gap12": `TabsNavigation-module__gap-12___vpt0u`,
	"gap14": `TabsNavigation-module__gap-14___Vr01U`,
	"gap16": `TabsNavigation-module__gap-16___dEvHr`,
	"gap18": `TabsNavigation-module__gap-18___mbFAi`,
	"gap20": `TabsNavigation-module__gap-20___KvzoH`,
	"gap24": `TabsNavigation-module__gap-24___CIi9s`,
	"gap26": `TabsNavigation-module__gap-26___iAwzW`,
	"gap30": `TabsNavigation-module__gap-30___MgLVc`,
	"gap32": `TabsNavigation-module__gap-32___Odvhj`,
	"gap40": `TabsNavigation-module__gap-40___urY7S`,
	"gap50": `TabsNavigation-module__gap-50___qmgIe`,
	"flex1": `TabsNavigation-module__flex-1___FhT2e`,
	"flexNone": `TabsNavigation-module__flex-none___di5Oe`,
	"flexColumn": `TabsNavigation-module__flex-column___zgrK2`,
	"flexRow": `TabsNavigation-module__flex-row___zaPim`,
	"verticallyCentered": `TabsNavigation-module__vertically-centered___sDlGK`,
	"horizontallyCentered": `TabsNavigation-module__horizontally-centered___liLCl`,
	"horizontallyEnd": `TabsNavigation-module__horizontally-end___o3hQh`,
	"verticallyStart": `TabsNavigation-module__vertically-start___Td1Q6`,
	"spaceBetween": `TabsNavigation-module__space-between___SQwhG`,
	"flexWrap": `TabsNavigation-module__flex-wrap___nbx8T`,
	"height100": `TabsNavigation-module__height-100___LXlpU`,
	"width50": `TabsNavigation-module__width-50___ecnMc`,
	"width100": `TabsNavigation-module__width-100___dRURS`,
	"cursorPointer": `TabsNavigation-module__cursor-pointer___kgZe1`,
	"cursorNotAllowed": `TabsNavigation-module__cursor-not-allowed___UzqkI`,
	"absoluteCentered": `TabsNavigation-module__absolute-centered___E571T`,
	"absolute": `TabsNavigation-module__absolute___QN37A`,
	"relative": `TabsNavigation-module__relative___rQI9I`,
	"fixed": `TabsNavigation-module__fixed___hkfe_`,
	"visible": `TabsNavigation-module__visible___CVXC3`,
	"invisible": `TabsNavigation-module__invisible___wNvf7`,
	"col90": `TabsNavigation-module__col-90___w9mVg`,
	"colAuto": `TabsNavigation-module__col-auto___un1qg`,
	"medicalTabs": `TabsNavigation-module__medical-tabs___wJ63d`,
	"medicalTableNew": `TabsNavigation-module__medical-table-new___fobDG`,
	"noPagination": `TabsNavigation-module__no-pagination___ChzXP`,
	"medicalTableEmpty": `TabsNavigation-module__medical-table-empty___niq04`,
	"iconBtn": `TabsNavigation-module__icon-btn___MqE40`,
	"searchIcon": `TabsNavigation-module__search-icon___iJlP7`,
	"disableSelect": `TabsNavigation-module__disable-select___zT2cK`,
	"breakWord": `TabsNavigation-module__break-word___UzDr_`,
	"popupClearBtn": `TabsNavigation-module__popup-clear-btn___i0oyw`,
	"scrollMB20": `TabsNavigation-module__scroll-m-b-20___reRgB`,
	"container": `TabsNavigation-module__container___xmDsp`
};
module.exports = ___CSS_LOADER_EXPORT___;
